import React from "react";

import ShopItemGridSkeleton from "../../molecules/ShopItemGrid/skeleton";

const SavedItemPageSkeleton = () => <ShopItemGridSkeleton />

export default SavedItemPageSkeleton;